/* Shopify storefront: preserve UTM in URLs. Load once with defer. */
(() => {
  'use strict';
  if (window.ShopAttribution) return;
  const STORAGE_KEY = 'shop_attribution_v1';
  const isUTM = key => /^utm_[a-z0-9_]{1,50}$/.test(key);
  const readUTM = url => Object.fromEntries(
    [...url.searchParams].filter(([key, value]) => isUTM(key) && value.trim())
  );
  let saved = {};
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      saved = Object.fromEntries(Object.entries(parsed).filter(
        ([key, value]) => isUTM(key) && typeof value === 'string' && value.trim()
      ));
    }
  } catch (_) { /* URL propagation still works if storage is unavailable. */ }

  const incoming = readUTM(new URL(location.href));
  // A new tagged visit replaces the complete campaign, avoiding mixed sources.
  const utm = Object.keys(incoming).length ? incoming : saved;
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm)); } catch (_) {}
  window.ShopAttribution = Object.freeze({ getUTM: () => ({ ...utm }) });
  if (!Object.keys(utm).length) return;

  // The cart page is supported; cart actions/permalinks are left untouched.
  const excluded = /\/(?:checkout|checkouts|account|admin|apps)(?:\/|$)|\/cart\/.+/i;
  function addUTM(url) {
    for (const [key, value] of Object.entries(utm)) url.searchParams.set(key, value);
    return url;
  }
  // Restore the visible URL on an untagged page in the same tab/session.
  if (!excluded.test(location.pathname)) {
    try {
      history.replaceState(history.state, '', addUTM(new URL(location.href)).href);
    } catch (_) {}
  }

  function decorate(link) {
    if (link.hasAttribute('download') || link.closest('[data-no-utm]')) return;
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    let url;
    try { url = new URL(raw, document.baseURI); } catch (_) { return; }
    if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin) return;
    if (excluded.test(url.pathname) || /\.(?:json|js|css|pdf|png|jpe?g|gif|svg|webp|zip)$/i.test(url.pathname)) return;
    // Explicit campaign links retain their own attribution.
    if (Object.keys(readUTM(url)).length) return;
    link.href = addUTM(url).href;
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.('a[href]')) decorate(root);
    root.querySelectorAll('a[href]').forEach(decorate);
  }
  scan(document);
  // Covers navigation, filters and sections inserted by Shopify themes.
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') decorate(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['href']
  });
  for (const eventName of ['click', 'auxclick', 'contextmenu']) {
    document.addEventListener(eventName, event => {
      const link = event.target.closest?.('a[href]');
      if (link) decorate(link);
    }, true);
  }
})();
